module.exports = __webpack_public_path__ + "img/treinamento.1d7b6a0f.png";